import { c as _c } from "react/compiler-runtime";
import BaseLink from "@/components/common/base-link/base-link";
import { Link } from "@/sanity/sanity.types";
interface IHomeNavigationItemWithSubnavigationButtonProps {
  link: Link;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}
const HomeNavigationItemWithSubnavigationButton = props => {
  const $ = _c(9);
  const {
    link,
    onMouseEnter,
    onMouseLeave
  } = props;
  if (link.href) {
    let t0;
    if ($[0] !== link.href || $[1] !== link.label || $[2] !== onMouseEnter || $[3] !== onMouseLeave) {
      t0 = <BaseLink href={link.href} className="font-size-[16px] !text-[#373B37] hover:!text-[#00698f] flex items-center justify-center cursor-pointer" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>{link.label}</BaseLink>;
      $[0] = link.href;
      $[1] = link.label;
      $[2] = onMouseEnter;
      $[3] = onMouseLeave;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    return t0;
  }
  let t0;
  if ($[5] !== link.label || $[6] !== onMouseEnter || $[7] !== onMouseLeave) {
    t0 = <button className="font-size-[16px] !text-[#373B37] hover:!text-[#00698f] flex items-center justify-center cursor-pointer" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>{link.label}</button>;
    $[5] = link.label;
    $[6] = onMouseEnter;
    $[7] = onMouseLeave;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  return t0;
};
export default HomeNavigationItemWithSubnavigationButton;